<template>
  <b-form @submit="onSubmit">
    <Loading :active="loading" :is-full-page="true"></Loading>
    <div class="row">
      <div class="col-sm-6">
        <b-form-group
          id="input-group-1"
          label="Servicio"
          label-for="select-service"
          description="Seleccione el tipo de servicio"
        >
          <b-form-select
            id="select-service"
            v-model="rq.service"
            :options="services"
            @change="changeService"
          ></b-form-select>
        </b-form-group>
      </div>
      <div class="col-sm-3">
        <b-form-group
          id="input-group-pax"
          label="Clientes"
          label-for="select-pax"
          description="# de pax"
        >
          <b-form-select
            id="select-service"
            v-model="rq.pax"
            :options="pax"
          ></b-form-select>
        </b-form-group>
      </div>
      <div class="col-sm-3">
        <b-form-group
          id="input-group-currency"
          label="Divisa"
          label-for="select-currency"
          description="Divisa"
        >
          <b-form-select
            id="select-currency"
            v-model="rq.currency"
            :options="currencies"
          ></b-form-select>
        </b-form-group>
      </div>
      <div class="col-sm-12 col-md-6">
        <b-form-group
          id="input-group-hotel"
          label="Desde"
          label-for="from-hotel"
          description="Buscar hotel"
        >
          <hotel-autocomplete
            :default-hotel.sync="fromHotel"
            :disabled="disabledFrom"
            id="fromHotel"
            @on-select-hotel="onSelectFromHotel"
          ></hotel-autocomplete> 
        </b-form-group>
      </div>
      <div class="col-sm-12 col-md-6">
        <b-form-group
          id="input-group-hotel"
          label="Hacia"
          label-for="to-hotel"
          description="Buscar hotel"
        >
          <hotel-autocomplete
            :default-hotel.sync="toHotel"
            :disabled="disabledTo"
            id="toHotel"
            @on-select-hotel="onSelectToHotel"
          ></hotel-autocomplete> 
        </b-form-group>
      </div>
      <div class="col">
        <b-button block type="submit" variant="primary">Cotizar</b-button>
      </div>
    </div>
  </b-form>
</template>
<script>
  //Vue.use(VueLoading)
  //const axios = require('axios');
  //import Loading from "@/components/Loading"
  export default {
    name:"QuoteBox",
    //componets:{Loading},
    props:{
      request:{
        required:true,
        type: Object
      }
    },
    data() {
      let pax = [];
      for (let index = 0; index < 40; index++) {
        pax.push(index)
      }
      return {
        pax,
        currencies:['usd', 'mxn'],
        services: [
          { value: 'a', text: 'LLegada' },
          { value: 'd', text: 'Salida' },
          { value: 'rt', text: 'Roundtrip' },
        ],
        disabledFrom: true,
        disabledTo: false,
        loading: false,
        rq: {...this.request},
        toHotel: {
          id: this.request.toHotel.id,
          value: this.request.toHotel.name,
        },
        fromHotel: {
          id: this.request.fromHotel.id,
          value: this.request.fromHotel.name,
        },
      }
    },
    methods: {
      validHotels() {
        let valid = true
        if (!this.rq.fromHotel.id) {
          valid = false
        }
        if (!this.rq.toHotel.id) {
          valid = false
        }
        return valid
      },
      onSubmit(e) {
        e.preventDefault()
        if (this.validHotels()) {
          this.quote()
        }
      },
      quote() {
        this.loading = true
        const url = `${process.env.MIX_APP_URL}/api-feraltar/quote-services`
        this.$store.dispatch('quote/setRequest', this.rq)
        this.$axios.post(url, this.rq).then(rs => {
          console.log('data.data', rs.data);
          this.$store.dispatch('quote/setData', rs.data)
          //this.$store.dispatch('setData', rs.data)
          this.loading = false
        })
        .catch(error=> {
          console.log('error quote', error);
          this.loading = false
        })
      },
      onSelectToHotel(data) {
        this.rq.toHotel.id = data.id
        this.rq.toHotel.name = data.value
      },
      onSelectFromHotel(data) {
        this.rq.fromHotel.id = data.id
        this.rq.fromHotel.name = data.value
      },
      changeService() {
        if (this.rq.service == 'a' || this.rq.service == 'rt') {
          this.disabledFrom = true
          this.disabledTo = false
          this.fromHotel = {
            id: process.env.MIX_AIRPORT_ID,
            value: process.env.MIX_AIRPORT_NAME,
          }
          this.toHotel = {
            id: '',
            value: '',
          }
          this.rq.fromHotel.id = process.env.MIX_AIRPORT_ID
          this.rq.fromHotel.name = process.env.MIX_AIRPORT_NAME
          this.rq.toHotel.id = ''
          this.rq.toHotel.name = ''
        }
        if (this.rq.service == 'd') {
          this.disabledFrom = false
          this.disabledTo = true
          this.toHotel = {
            id: process.env.MIX_AIRPORT_ID,
            value: process.env.MIX_AIRPORT_NAME,
          }
          this.fromHotel = {
            id: '',
            value: '',
          }
          this.rq.toHotel.id = process.env.MIX_AIRPORT_ID
          this.rq.toHotel.name = process.env.MIX_AIRPORT_NAME
          this.rq.fromHotel.id = ''
          this.rq.fromHotel.name = ''
        }
      }
    },
  }
</script>